import React, { useState } from 'react';
import {
  Box,
  Typography,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Policy as PolicyIcon
} from '@mui/icons-material';

const EventPolicyComponent = ({ eventPolicy }) => {
  const [expanded, setExpanded] = useState(false);

  if (!eventPolicy) return null;

  const toggleExpanded = () => setExpanded(!expanded);

  return (
    <Box sx={{ mb: 2 }}>
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          cursor: 'pointer',
          color: 'primary.main'
        }}
        onClick={toggleExpanded}
      >
        <PolicyIcon fontSize="small" sx={{ mr: 1 }} />
        <Typography variant="subtitle2">
          Event Policies
        </Typography>
        <IconButton size="small" sx={{ ml: 1 }}>
          {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <List dense sx={{ py: 0, mt: 1 }}>
          {eventPolicy.refundPolicy?.description && (
            <ListItem sx={{ py: 0.5, ml: 3 }}>
              <ListItemText 
                primary={`• ${eventPolicy.refundPolicy.description}`}
                secondary={ eventPolicy.refundPolicy.deadlineDays && `Refund deadline: ${eventPolicy.refundPolicy.deadlineDays} days`}
                sx={{ my: 0 }}
              />
            </ListItem>
          )}
          
          {eventPolicy.processingFeesPolicy?.feeDescription && (
            <ListItem sx={{ py: 0.5,  ml: 3 }}>
              <ListItemText 
                primary={`• ${eventPolicy.processingFeesPolicy.feeDescription}`}
                secondary={`Fees: ${eventPolicy.processingFeesPolicy.purchaseFeePercentage}% purchase, ${eventPolicy.processingFeesPolicy.refundFeePercentage}% refund`}
                sx={{ my: 0 }}
              />
            </ListItem>
          )}
          
          {eventPolicy.ageRestrictionPolicy?.description && (
            <ListItem sx={{ py: 0.5,  ml: 3 }}>
              <ListItemText 
                primary={`• ${eventPolicy.ageRestrictionPolicy.description}`}
                secondary={
                  eventPolicy.ageRestrictionPolicy.minAge || eventPolicy.ageRestrictionPolicy.idRequired 
                    ? `${eventPolicy.ageRestrictionPolicy.minAge ? `Minimum age: ${eventPolicy.ageRestrictionPolicy.minAge}+` : ''}${eventPolicy.ageRestrictionPolicy.idRequired ? ' • ID required' : ''}`
                    : null
                }
                sx={{ my: 0 }}
              />
            </ListItem>
          )}
          
          {eventPolicy.cancellationPolicy?.description && (
            <ListItem sx={{ py: 0.5,  ml: 3 }}>
              <ListItemText 
                primary={`• ${eventPolicy.cancellationPolicy.description}`}
                sx={{ my: 0 }}
              />
            </ListItem>
          )}
          
          {eventPolicy.mediaPolicy?.description && (
            <ListItem sx={{ py: 0.5, ml: 3 }}>
              <ListItemText 
                primary={`• ${eventPolicy.mediaPolicy.description}`}
                sx={{ my: 0 }}
              />
            </ListItem>
          )}
        </List>
      </Collapse>
    </Box>
  );
};

export default EventPolicyComponent;